import { render, staticRenderFns } from "./GmailColorful.vue?vue&type=template&id=5b372520&"
import script from "./GmailColorful.vue?vue&type=script&lang=ts&"
export * from "./GmailColorful.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports